enum constants {
	parentContainerId = '_idContainer',
	textFieldWrapperClassName = '_idGenObjectAttribute',
	textFieldCharacterClassName = 'CharOverride',
	textFieldClassName = 'editable-text',
	imageClassName = 'editable-image',
	videoClassName = 'editable-video',
	animationClassName = 'editable-animation',
	iframeClassName = 'editable-iframe',
	sliderClassName = 'plugin-slider',
	editableSliderClassName = 'editable-plugin-slider',
	sliderPreviewClassName = 'plugin-preview-slider',
	videoOrIframeWrapperId = '_idHTMLPageItem',
	buttonClassName = '_idGenButton',
	buttonStateClassName = '_idGen-Appearance',
	animationStartClassName = '_idGenAnimationStart',
	animationEndStateDataAttribute = 'idgenanimationendstate',
	// inDesign puts this on the top element of a page, whichever way the publication was exported
	pageLoadHandlerAttribute = 'onload',
	editableButtonClassName = 'editable-button',
	editableButtonLinkClassName = 'editable-button-link',
	editableButtonLinkGraphicsClassName = '_idGenObjectStyle',
	lockedClassName = 'locked',
	lockedIconClassName = 'locked-icon',
	scrollableAreaClassName = 'plugin-animationScrollableBox',
	enrichmentClassName = 'webpublication-enrichment',
	themedItemClassName = 'webPublication-theme-color',
	pageIndexInSpreadClassName = 'page-index',
	multiStateObjectClassName = '_idGenMSO',
	multiStateObjectDataAttribute = 'data-idgenobjectstate',
}

export enum EnrichmentType {
	openNewTab = 'openNewTab',
	openSameTab = 'openSameTab',
	popup = 'popup',
}

export const accessibleVersionTextElements = 'h1, h2, h3, h4, h5, h6, p, figcaption, li, code';

export default constants;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/constants.ts